import React, { forwardRef } from 'react';
import { clsx } from '@mentimeter/ragnar-tailwind-config';
import { Box } from '../box';
import { Text } from '../text';
import { CheckItem } from '../check-item';
import { useRadioGroup } from './RadioGroupContext';
import { RadioGroupItemGeneric } from './RadioGroupItemGeneric';
import type { RadioGroupItemGenericProps } from './RadioGroupItemGeneric';

export const RadioGroupItemList = forwardRef(
  <T extends string | number>(
    { children, className, ...props }: RadioGroupItemGenericProps<T>,
    ref: React.Ref<HTMLDivElement>,
  ) => {
    const { value: selectedValue } = useRadioGroup();
    const isSelectedItem = props.value === selectedValue;

    const defaultClasses = [
      'w-full',
      'p-4',
      'rounded-none',
      'ml-0',
      '-mb-[2px]', // to collapse borders
      'first:rounded-t-lg',
      'last:rounded-b-lg',
      'last:mb-0',
    ];

    return (
      <RadioGroupItemGeneric
        className={clsx(defaultClasses, className)}
        ref={ref}
        {...props}
      >
        <Box className="w-full flex-row items-center justify-between gap-5">
          <Text className="text-initial">{children}</Text>
          <Box className="pointer-events-none mr-2">
            <CheckItem
              name=""
              type="radio"
              checked={isSelectedItem}
              readOnly
              size="compact"
              aria-hidden
              tabIndex={-1}
            />
          </Box>
        </Box>
      </RadioGroupItemGeneric>
    );
  },
);
